<script>
    import { page } from '$app/stores';
    import { get_is_admin } from './utils/is_admin';
    import {
        img_cdn,
        img_responsive_srcset,
        img_responsive_sizes
    } from './utils/image';
    import { logEvent } from './utils/logs';

    let className = '';
    export { className as class };

    const v_options = { xl: { w: 220 } };
    const h_options = { xl: { w: 320 } };

    let is_admin_value = false;
    get_is_admin().then((v) => (is_admin_value = v || false));

    let show_all = false;

    $: rows = $page.data.hero_pane?.rows || [];
    $: visible_rows = show_all ? rows : [...rows, ...rows];
</script>

<div
    class="hero-pane-root {className}"
    class:hero-pane-root--show-all={show_all}
>
    {#if is_admin_value}
        <label class="hero-pane__admin-toggle">
            <input type="checkbox" bind:checked={show_all} />
            <span>Show all</span>
        </label>
    {/if}
    <div class="hero-pane">
        <div class="hero-pane__track" style="--set-rows: {rows.length}">
            {#each visible_rows as row}
            <div class="hero-pane__row">
                {#each row as item}
                    <a
                        class="hero-pane__cell hero-pane__cell--{item.orient}"
                        href={item.href}
                        on:click={() => logEvent('hero-pane-click')}
                    >
                        <img
                            class="hero-pane__image"
                            src={img_cdn(
                                item.src,
                                item.orient === 'v' ? { w: 220 } : { w: 320 }
                            )}
                            srcset={img_responsive_srcset(
                                item.src,
                                item.orient === 'v' ? v_options : h_options
                            )}
                            sizes={img_responsive_sizes(
                                item.orient === 'v' ? v_options : h_options
                            )}
                            alt={item.title}
                            draggable="false"
                        />
                    </a>
                {/each}
            </div>
            {/each}
        </div>
    </div>
</div>

<style>
    .hero-pane-root--show-all {
        bottom: auto !important;
        height: auto !important;
    }

    .hero-pane-root--show-all .hero-pane {
        height: auto;
        overflow: visible;
        mask-image: none;
        -webkit-mask-image: none;
        background-color: #000;
    }

    .hero-pane-root--show-all .hero-pane__track {
        animation: none;
        transform: translate3d(0, 0, 0);
    }

    .hero-pane__admin-toggle {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        z-index: 20;
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.3rem 0.6rem;
        background: var(--surface-default);
        border: 1px solid var(--border-default);
        border-radius: 0.5rem;
        font-size: 0.8rem;
        color: var(--symbols-default);
        cursor: pointer;
        user-select: none;
    }

    .hero-pane {
        width: 100%;
        height: 100%;
        overflow: hidden;
        padding: 0 4px;
        mask-image: linear-gradient(
            to bottom,
            transparent 0%,
            black 14%,
            black 86%,
            transparent 100%
        );
        -webkit-mask-image: linear-gradient(
            to bottom,
            transparent 0%,
            black 14%,
            black 86%,
            transparent 100%
        );
    }

    .hero-pane__track {
        --row-height: 330px;
        --row-duration: 7.5s;
        --set-height: calc(var(--row-height) * var(--set-rows, 4));
        display: flex;
        flex-direction: column;
        gap: 0;
        animation: hero-pane-scroll calc(var(--row-duration) * var(--set-rows, 4))
            linear infinite;
        will-change: transform;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
    }

    .hero-pane:hover .hero-pane__track {
        animation-play-state: paused;
    }

    .hero-pane__row {
        display: flex;
        gap: 2.4rem;
        align-items: center;
        height: var(--row-height);
    }

    .hero-pane__cell {
        display: block;
        flex-shrink: 0;
        overflow: hidden;
        border: 2px solid var(--border-muted);
        border-radius: 1.2rem;
        background-color: var(--surface-default);
        transition: transform 100ms linear, border 150ms linear;
    }

    .hero-pane__cell:hover {
        transform: rotate(0deg) !important;
        border-color: var(--border-default);
    }

    .hero-pane__cell--v {
        width: 220px;
        height: 330px;
    }

    .hero-pane__cell--v:first-child {
        margin-left: 3rem;
        transform: rotate(-1.2deg);        
    }
    
    .hero-pane__cell--v:last-child {
        transform: rotate(-.6deg);
    }

    .hero-pane__cell--h {
        width: 320px;
        height: 240px;
    }

    .hero-pane__cell--h:first-child {
        transform: rotate(1.5deg);
    }

    .hero-pane__cell--h:last-child {
        transform: rotate(-1.5deg);
    }



    .hero-pane__image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        user-select: none;
        object-position: top center;
    }

    @keyframes hero-pane-scroll {
        from {
            transform: translate3d(0, 0, 0);
        }
        to {
            transform: translate3d(0, calc(var(--set-height) * -1), 0);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .hero-pane__track {
            animation: none;
        }
    }
</style>
